import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import "../styles/Projects.css"; 

const Projects = () => {
  const [layouts, setLayouts] = useState([]);

  useEffect(() => {
    fetch("https://api.ssvdevelopers.co.in/layouts")
      .then((res) => res.json())
      .then((data) => setLayouts(data))
      .catch((err) => console.error("Error fetching layouts:", err));
  }, []);

  return (
    <div className="projects-container">
      <Sidebar />

      <div className="projects-main">
        <h2 className="projects-title">🏗️ Our Projects</h2>

        {layouts.map((layout, index) => (
          <div key={layout._id || index} className="projects-content">
            {/* Layout Image */}
            <img
              src={`https://api.ssvdevelopers.co.in${layout.image}`} 
              alt={layout.name}
              className="layout-img"
            />

            {/* Legend Box */}
            <div className="legend-box">
              <h3>{layout.name} – Plot Status</h3>

              <div className="legend-section">
                <span className="legend-label red">Booked:</span>
                <span>{layout.booked.join(", ") || "None"}</span>
              </div>

              <div className="legend-section">
                <span className="legend-label pink">On Hold:</span>
                <span>{layout.onHold.join(", ") || "None"}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
